<script setup>
import {inject, ref} from "vue";
import startupsService from "@/services/startups.service";
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";

const form = inject('form');
const id = inject('id');
const loading = ref(false);

async function sync() {
    loading.value = true;
    const {data} = await startupsService.syncPatents(id.value);
    form.patents = data;
    loading.value = false;
}

function add() {
    form.patents.push({
        num: '',
        title: '',
        assignor: '',
        assignee: ''
    })
}
</script>

<template>
    <StartupEditField
        field-name="patents"
        label="Patents"
    >
        <template #input>
            <div class="mb-2">
                <span v-if="loading">Syncing...</span>
                <a v-else class="link" @click="sync">Sync Patents</a>
            </div>

            <div v-for="(patent, index) in form.patents" :key="index">
                <input class="form-control form-control--mid mb-2" v-model="form.patents[index].num">
                <input class="form-control form-control--mid mb-2" v-model="form.patents[index].title">
                <input class="form-control form-control--mid mb-2" v-model="form.patents[index].assignor">
                <input class="form-control form-control--mid mb-2" v-model="form.patents[index].assignee">
                <hr>
            </div>

            <a class="link" @click="add">+Add Patent</a>
        </template>
    </StartupEditField>
</template>

<style scoped>

</style>
